import React from 'react';
import {
	ImageBackground,
	KeyboardAvoidingView,
	Platform,
	StyleSheet,
	View,
} from 'react-native';
import colors from '../../../config/colors';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import useDevicePlatform, {
	DeviceType,
} from '../../../hooks/useDevicePlatform.hook';


interface SignInV2LayoutProps {
	children: React.ReactNode;
}

/** shared card shell for all V2 sign-in steps: background, centered card, logo */
const SignInV2Layout = ({ children }: SignInV2LayoutProps) => {
	const currPlatform = useDevicePlatform();
	const isMobile: boolean = currPlatform !== DeviceType.WEB;

	return (
		<View style={styles.wrapper}>
				<KeyboardAvoidingView
					behavior='padding'
					enabled={Platform.OS === 'ios'}
					keyboardVerticalOffset={100}
				>
					<View
						style={[
							styles.card,
							{ width: isMobile ? 334 : 448 },
						]}
					>
						<View style={styles.container}>
							<View style={styles.logoSection}>
								<ImageIcon
									name={'Logo'}
									width={126}
									height={32}
								/>
							</View>
							{children}
						</View>
					</View>
				</KeyboardAvoidingView>
		</View>
	);
};

const styles = StyleSheet.create({
	wrapper: {
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
		height: '100%',
		width: '100%',
		backgroundColor: colors.loginBackground,
	},
	image: {
		resizeMode: 'center',
		height: '100%',
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		minWidth: 500,
	},
	card: {
		backgroundColor: colors.white,
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 8,
		paddingHorizontal: 32,
		paddingVertical: 32,
		shadowColor: '#000',
		shadowOffset: { width: 2, height: 2 },
		shadowOpacity: 0.04,
		shadowRadius: 16,
		elevation: 4,


	},
	container: {
		flexDirection: 'column',
		width: '100%',
	},
	logoSection: {
		marginBottom: 32,
		justifyContent: 'center',
		flexDirection: 'row',
		alignItems: 'center',
	},
});

export default SignInV2Layout;
